<template>
  <div class="mv-page">
    <div class="mv-page__header">
      <h1 class="mv-page__title">MV</h1>
      <p class="mv-page__subtitle">正版原创曲库，尊重每一份音乐创作</p>
    </div>

    <div class="mv-page__grid">
      <router-link
        v-for="(mv, index) in mvs"
        :key="mv.id"
        :to="{ path: '/mvxq', query: { id: mv.id } }"
        class="mv-page__card"
        :style="{ animationDelay: `${index * 0.05}s` }"
        @mouseenter.native="hoveredCard = mv.id"
        @mouseleave.native="hoveredCard = null"
      >
        <div class="mv-page__card-inner">
          <div class="mv-page__card-img-wrap">
            <img :src="mv.image" :alt="mv.title" class="mv-page__card-img" />
            <div class="mv-page__card-overlay" :class="{ 'mv-page__card-overlay--visible': hoveredCard === mv.id }">
              <div class="mv-page__card-play">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <polygon points="5 3 19 12 5 21 5 3"></polygon>
                </svg>
              </div>
            </div>
            <div class="mv-page__card-badge" v-if="mv.isnovip == 1">VIP</div>
          </div>
          
          <div class="mv-page__card-content">
            <h3 class="mv-page__card-title">{{ mv.title }}</h3>
            <p class="mv-page__card-artist">{{ mv.author }}</p>
            <div class="mv-page__card-stats">
              <span class="mv-page__card-stat">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                  <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon>
                  <path d="M15.54 8.46a5 5 0 0 1 0 7.07"></path>
                  <path d="M19.07 4.93a10 10 0 0 1 0 14.14"></path>
                </svg>
                {{ formatNumber(mv.bofang) }}
              </span>
              <span class="mv-page__card-stat">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                  <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
                </svg>
                {{ formatNumber(mv.zan) }}
              </span>
            </div>
          </div>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'Mv',
  data() {
    return {
      hoveredCard: null,
      mvs: []
    }
  },
  mounted() {
    const audio = this.$parent.$refs.audioPlayer
    if (audio && !audio.paused) {
      audio.pause()
      this.$store.commit('setPlaying', false)
    }
    this.loadMvList()
  },
  methods: {
    loadMvList() {
      axios.get('https://xinyinyue.xiangyouhulian.cn/api/index/mv')
        .then(response => {
          const data = response.data
          if (data.data) {
            this.mvs = data.data
          } else {
            this.mvs = data
          }
        })
        .catch(error => {
          console.error('获取MV列表失败:', error)
        })
    },
    formatNumber(num) {
      const n = parseInt(num)
      if (n >= 10000) {
        return (n / 10000).toFixed(1) + '万'
      }
      return n.toString()
    }
  }
}
</script>

<style scoped lang="scss">
.mv-page {
  width: 100%;
  min-height: 100vh;
  font-family: Arial, Helvetica, sans-serif;
  padding: 40px 20px 40px 20px;
  box-sizing: border-box;
  background-image: url('../../assets/hoem.jpg');
  background-size: cover;
  background-position: center center;
  background-attachment: fixed;
  background-repeat: no-repeat;
  background-color: #1a1a1a;

  &__header {
    text-align: center;
    margin-bottom: 40px;
  }

  &__title {
    font-size: 36px;
    font-weight: 700;
    color: #ffffff;
    margin: 0 0 10px 0;
    letter-spacing: 1px;
  }

  &__subtitle {
    font-size: 16px;
    color: #ffffff;
    margin: 0;
    line-height: 1.6;
  }

  &__filters {
    display: flex;
    justify-content: center;
    gap: 12px;
    margin-bottom: 40px;
    flex-wrap: wrap;
  }

  &__filter {
    padding: 10px 24px;
    background-color: #ffffff;
    border: 1px solid #e0e0e0;
    border-radius: 25px;
    color: #666666;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

    &:hover {
      border-color: #9a1f13;
      color: #9a1f13;
      transform: translateY(-2px);
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    }

    &--active {
      background-color: #9a1f13;
      border-color: #9a1f13;
      color: #ffffff;
      box-shadow: 0 4px 12px rgba(154, 31, 19, 0.3);

      &:hover {
        color: #ffffff;
        background-color: #8a1a12;
      }
    }
  }

  &__grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
    gap: 24px;
    max-width: 1400px;
    margin: 0 auto;
  }

  &__card {
    background-color: #ffffff;
    border-radius: 12px;
    overflow: hidden;
    cursor: pointer;
    animation: fadeInUp 0.5s ease forwards;
    opacity: 0;
    transform: translateY(20px);
    transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
    border: 1px solid #b02518;

    &:hover {
      transform: translateY(-8px) scale(1.02);
      border-color: #9a1f13;
      box-shadow: 0 12px 32px rgba(154, 31, 19, 0.15), 0 0 0 2px rgba(154, 31, 19, 0.3);
    }

    &-inner {
      display: flex;
      flex-direction: column;
    }

    &-img-wrap {
      position: relative;
      width: 100%;
      padding-top: 56.25%;
      overflow: hidden;
    }

    &-img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: transform 0.4s ease;
      border-radius: 12px 12px 0 0;
    }

    &:hover &-img {
      transform: scale(1.1);
    }

    &-overlay {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0, 0, 0, 0.6);
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      opacity: 0;
      transition: opacity 0.3s ease;
      backdrop-filter: blur(2px);
    }

    &-overlay--visible {
      opacity: 1;
    }

    &-play {
      width: 64px;
      height: 64px;
      background-color: rgba(255, 255, 255, 0.95);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #9a1f13;
      transition: transform 0.3s ease;
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);

      svg {
        width: 28px;
        height: 28px;
        margin-left: 4px;
      }
    }

    &:hover &-play {
      transform: scale(1.1);
    }

    &-duration {
      position: absolute;
      bottom: 12px;
      right: 12px;
      padding: 4px 8px;
      background-color: rgba(0, 0, 0, 0.7);
      border-radius: 4px;
      color: #ffffff;
      font-size: 12px;
      font-weight: 500;
    }

    &-badge {
      position: absolute;
      top: 12px;
      left: 12px;
      padding: 4px 12px;
      background-color: #f37021;
      border-radius: 4px;
      color: #ffffff;
      font-size: 12px;
      font-weight: 600;
      text-transform: uppercase;
      letter-spacing: 0.5px;
    }

    &-content {
      padding: 20px;
      flex: 1;
      display: flex;
      flex-direction: column;
    }

    &-title {
      font-size: 16px;
      font-weight: 600;
      color: #333333;
      margin: 0 0 8px 0;
      line-height: 1.4;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      transition: color 0.2s ease;
    }

    &:hover &-title {
      color: #9a1f13;
    }

    &-artist {
      font-size: 14px;
      color: #999999;
      margin: 0 0 12px 0;
      transition: color 0.2s ease;
    }

    &:hover &-artist {
      color: #666666;
    }

    &-stats {
      display: flex;
      gap: 20px;
      margin-top: auto;
    }

    &-stat {
      display: flex;
      align-items: center;
      gap: 6px;
      font-size: 12px;
      color: #999999;

      svg {
        width: 14px;
        height: 14px;
      }
    }
  }

  &__footer {
    text-align: center;
    margin-top: 40px;
  }

  &__load-more {
    padding: 14px 48px;
    background-color: #9a1f13;
    border: none;
    border-radius: 30px;
    color: #ffffff;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 4px 12px rgba(154, 31, 19, 0.3);

    &:hover {
      background-color: #8a1a12;
      transform: translateY(-2px);
      box-shadow: 0 6px 20px rgba(154, 31, 19, 0.4);
    }

    &:active {
      transform: translateY(0);
    }
  }

  @media (max-width: 768px) {
    padding: 20px 15px 120px 15px;

    &__title {
      font-size: 28px;
    }

    &__subtitle {
      font-size: 14px;
    }

    &__grid {
      grid-template-columns: 1fr;
      gap: 20px;
    }

    &__filter {
      padding: 8px 18px;
      font-size: 13px;
    }

    &__card-content {
      padding: 16px;
    }

    &__card-title {
      font-size: 15px;
    }

    &__card-artist {
      font-size: 13px;
    }
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>